import axios from 'axios';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { domainResolver } from './utils';
import configureStore from './store';

const initialState = {};

const store = configureStore(initialState);
axios.defaults.baseURL = `/${process.env.REACT_APP_PATH}/api/${domainResolver()}/`;

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
